document.addEventListener('DOMContentLoaded', function () {
    // Event-Daten (Beispiel-Events)
    const events = [
        { name: 'Platzhalter', date: '2024-10-15', type: 'Magic' },
        { name: 'Platzhalter', date: '2024-10-22', type: 'Yugioh' },
        { name: 'Platzhalter', date: '2024-10-29', type: 'Lorcana' },
        // Weitere Events hinzufügen
    ];

    // Funktion zur Datumsformatierung
    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const date = new Date(dateString);
        return date.toLocaleDateString('de-DE', options);
    }

    // Funktion zum Anzeigen der Events
    function anzeigenEvents() {
        const eventListe = document.getElementById('eventListe');
        if (!eventListe) {
            console.error('Element mit ID "eventListe" nicht gefunden.');
            return;
        }
        eventListe.innerHTML = '';
        events.forEach(function (event) {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = '#';
            a.innerText = `${event.name} am ${formatDate(event.date)}`;
            a.style.cursor = 'pointer';

            // Event-Listener hinzufügen
            a.addEventListener('click', function (e) {
                e.preventDefault();
                openForm(event);
            });

            li.appendChild(a);
            eventListe.appendChild(li);
        });
    }

    // Funktion zum Öffnen des Formulars
    function openForm(eventData) {
        console.log('openForm aufgerufen mit:', eventData);

        // Zeige das Formular
        const formContainer = document.getElementById('formContainer');
        if (!formContainer) {
            console.error('Element mit ID "formContainer" nicht gefunden.');
            return;
        }
        formContainer.style.display = 'block';
        formContainer.scrollIntoView({ behavior: 'smooth' });

        // Verzögerung hinzufügen, um sicherzustellen, dass die Formularfelder geladen sind
        setTimeout(function () {
            // Füllen der Formularfelder
            const formEvent = document.querySelector('.globo-formbuilder [name="text-2"]');
            const formDate = document.querySelector('.globo-formbuilder [name="text-3"]');

            if (formEvent && formDate) {
                formEvent.value = eventData.name;
                formDate.value = eventData.date;
                console.log('Formularfelder gefüllt.');
            } else {
                console.log('Formularfelder nicht gefunden.');
            }
        }, 500); // 500ms Verzögerung, kann bei Bedarf angepasst werden
    }

    // Initialisieren der Events (Liste anzeigen)
    anzeigenEvents();
});
